import { _request, APIBaseResponse,APIMethod } from '../';

const BILLING_SYSTEMS_PREFIX = '/billingsystems';

type APIBillingSystemsResponse = APIBaseResponse<
    Array<{
        id: string;
        name: string;
    }>
>;

export const APIBillingSystemsGetList: APIMethod<void, APIBillingSystemsResponse> = () => (
    _request<APIBillingSystemsResponse>('GET', BILLING_SYSTEMS_PREFIX)
);
